const setItem = (key: string, value: string) => {
   if (typeof window !== 'undefined') {
      localStorage.setItem(key, value)
   }
}
export default setItem
